export const GET_ACCESS_TOKEN = 'GET_ACCESS_TOKEN';
export const GET_ACCESS_TOKEN_REQUEST = 'GET_ACCESS_TOKEN_REQUEST';
export const GET_ACCESS_TOKEN_SUCCESS = 'GET_ACCESS_TOKEN_SUCCESS';
export const GET_ACCESS_TOKEN_ERROR = 'GET_ACCESS_TOKEN_ERROR';

export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';

export const SET_TOAST = 'SET_TOAST';

export const SET_PATIENTS_PAGINATION = 'SET_PATIENTS_PAGINATION';

export const LOGOUT_DOCTOR = 'LOGOUT_DOCTOR';
export const LOGOUT_DOCTOR_REQUEST = 'LOGOUT_DOCTOR_REQUEST';
export const LOGOUT_DOCTOR_SUCCESS = 'LOGOUT_DOCTOR_SUCCESS';
export const LOGOUT_DOCTOR_ERROR = 'LOGOUT_DOCTOR_ERROR';

export const GET_PATIENTS = 'GET_PATIENTS';
export const GET_PATIENTS_REQUEST = 'GET_PATIENTS_REQUEST';
export const GET_PATIENTS_SUCCESS = 'GET_PATIENTS_SUCCESS';
export const GET_PATIENTS_ERROR = 'GET_PATIENTS_ERROR';

export const GET_PATIENT = 'GET_PATIENT';
export const GET_PATIENT_REQUEST = 'GET_PATIENT_REQUEST';
export const GET_PATIENT_SUCCESS = 'GET_PATIENT_SUCCESS';
export const GET_PATIENT_ERROR = 'GET_PATIENT_ERROR';

export const DELETE_PATIENT = 'DELETE_PATIENT';
export const DELETE_PATIENT_REQUEST = 'DELETE_PATIENT_REQUEST';
export const DELETE_PATIENT_SUCCESS = 'DELETE_PATIENT_SUCCESS';
export const DELETE_PATIENT_ERROR = 'DELETE_PATIENT_ERROR';

export const CREATE_PATIENT = 'CREATE_PATIENT';
export const CREATE_PATIENT_REQUEST = 'CREATE_PATIENT_REQUEST';
export const CREATE_PATIENT_SUCCESS = 'CREATE_PATIENT_SUCCESS';
export const CREATE_PATIENT_ERROR = 'CREATE_PATIENT_ERROR';

export const EDIT_PATIENT = 'EDIT_PATIENT';
export const EDIT_PATIENT_REQUEST = 'EDIT_PATIENT_REQUEST';
export const EDIT_PATIENT_SUCCESS = 'EDIT_PATIENT_SUCCESS';
export const EDIT_PATIENT_ERROR = 'EDIT_PATIENT_ERROR';

export const GET_TREATMENT_TEMPLATES = 'GET_TREATMENT_TEMPLATES';
export const GET_TREATMENT_TEMPLATES_REQUEST = 'GET_TREATMENT_TEMPLATES_REQUEST';
export const GET_TREATMENT_TEMPLATES_SUCCESS = 'GET_TREATMENT_TEMPLATES_SUCCESS';
export const GET_TREATMENT_TEMPLATES_ERROR = 'GET_TREATMENT_TEMPLATES_ERROR';

export const GET_MEDICATION_TEMPLATES_REQUEST = 'GET_MEDICATION_TEMPLATES_REQUEST';
export const GET_MEDICATION_TEMPLATES_SUCCESS = 'GET_MEDICATION_TEMPLATES_SUCCESS';
export const GET_MEDICATION_TEMPLATES_ERROR = 'GET_MEDICATION_TEMPLATES_ERROR';

export const GET_TREATMENT_TEMPLATE = 'GET_TREATMENT_TEMPLATE';
export const GET_TREATMENT_TEMPLATE_REQUEST = 'GET_TREATMENT_TEMPLATE_REQUEST';
export const GET_TREATMENT_TEMPLATE_SUCCESS = 'GET_TREATMENT_TEMPLATE_SUCCESS';
export const GET_TREATMENT_TEMPLATE_ERROR = 'GET_TREATMENT_TEMPLATE_ERROR';

export const GET_MEDICATION_TEMPLATE_REQUEST = 'GET_MEDICATION_TEMPLATE_REQUEST';
export const GET_MEDICATION_TEMPLATE_SUCCESS = 'GET_MEDICATION_TEMPLATE_SUCCESS';
export const GET_MEDICATION_TEMPLATE_ERROR = 'GET_MEDICATION_TEMPLATE_ERROR';

export const RECALCULATE_TREATMENT_TEMPLATE = 'RECALCULATE_TREATMENT_TEMPLATE';
export const RECALCULATE_TREATMENT_TEMPLATE_REQUEST = 'RECALCULATE_TREATMENT_TEMPLATE_REQUEST';
export const RECALCULATE_TREATMENT_TEMPLATE_SUCCESS = 'RECALCULATE_TREATMENT_TEMPLATE_SUCCESS';
export const RECALCULATE_TREATMENT_TEMPLATE_ERROR = 'RECALCULATE_TREATMENT_TEMPLATE_ERROR';

export const RECALCULATE_PATIENT_TREATMENT_TEMPLATE = 'RECALCULATE_PATIENT_TREATMENT_TEMPLATE';
export const RECALCULATE_PATIENT_TREATMENT_TEMPLATE_REQUEST =
  'RECALCULATE_PATIENT_TREATMENT_TEMPLATE_REQUEST';
export const RECALCULATE_PATIENT_TREATMENT_TEMPLATE_SUCCESS =
  'RECALCULATE_PATIENT_TREATMENT_TEMPLATE_SUCCESS';
export const RECALCULATE_PATIENT_TREATMENT_TEMPLATE_ERROR =
  'RECALCULATE_PATIENT_TREATMENT_TEMPLATE_ERROR';

export const CREATE_TREATMENT_TEMPLATE = 'CREATE_TREATMENT_TEMPLATE';
export const CREATE_TREATMENT_TEMPLATE_REQUEST = 'CREATE_TREATMENT_TEMPLATE_REQUEST';
export const CREATE_TREATMENT_TEMPLATE_SUCCESS = 'CREATE_TREATMENT_TEMPLATE_SUCCESS';
export const CREATE_TREATMENT_TEMPLATE_ERROR = 'CREATE_TREATMENT_TEMPLATE_ERROR';

export const CREATE_MEDICATION_TEMPLATE_REQUEST = 'CREATE_MEDICATION_TEMPLATE_REQUEST';
export const CREATE_MEDICATION_TEMPLATE_SUCCESS = 'CREATE_MEDICATION_TEMPLATE_SUCCESS';
export const CREATE_MEDICATION_TEMPLATE_ERROR = 'CREATE_MEDICATION_TEMPLATE_ERROR';

export const UPDATE_MEDICATION_TEMPLATE_REQUEST = 'UPDATE_MEDICATION_TEMPLATE_REQUEST';
export const UPDATE_MEDICATION_TEMPLATE_SUCCESS = 'UPDATE_MEDICATION_TEMPLATE_SUCCESS';
export const UPDATE_MEDICATION_TEMPLATE_ERROR = 'UPDATE_MEDICATION_TEMPLATE_ERROR';

export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const DELETE_TEMPLATE_REQUEST = 'DELETE_TEMPLATE_REQUEST';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';
export const DELETE_TEMPLATE_ERROR = 'DELETE_TEMPLATE_ERROR';

export const DELETE_MEDICATION_TEMPLATE_REQUEST = 'DELETE_MEDICATION_TEMPLATE_REQUEST';
export const DELETE_MEDICATION_TEMPLATE_SUCCESS = 'DELETE_MEDICATION_TEMPLATE_SUCCESS';
export const DELETE_MEDICATION_TEMPLATE_ERROR = 'DELETE_MEDICATION_TEMPLATE_ERROR';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';

export const APPLY_TREATMENT_PLAN = 'APPLY_TREATMENT_PLAN';
export const APPLY_TREATMENT_PLAN_REQUEST = 'APPLY_TREATMENT_PLAN_REQUEST';
export const APPLY_TREATMENT_PLAN_SUCCESS = 'APPLY_TREATMENT_PLAN_SUCCESS';
export const APPLY_TREATMENT_PLAN_ERROR = 'APPLY_TREATMENT_PLAN_ERROR';

export const APPLY_MEDICATION_TEMPLATE_REQUEST = 'APPLY_MEDICATION_TEMPLATE_REQUEST';
export const APPLY_MEDICATION_TEMPLATE_SUCCESS = 'APPLY_MEDICATION_TEMPLATE_SUCCESS';
export const APPLY_MEDICATION_TEMPLATE_ERROR = 'APPLY_MEDICATION_TEMPLATE_ERROR';

export const GET_CLICKING_DATA = 'GET_CLICKING_DATA';
export const GET_CLICKING_DATA_REQUEST = 'GET_CLICKING_DATA_REQUEST';
export const GET_CLICKING_DATA_SUCCESS = 'GET_CLICKING_DATA_SUCCESS';
export const GET_CLICKING_DATA_ERROR = 'GET_CLICKING_DATA_ERROR';

export const GET_DEFAULT_MEDICATIONS_REQUEST = 'GET_DEFAULT_MEDICATIONS_REQUEST';
export const GET_DEFAULT_MEDICATIONS_SUCCESS = 'GET_DEFAULT_MEDICATIONS_SUCCESS';
export const GET_DEFAULT_MEDICATIONS_ERROR = 'GET_DEFAULT_MEDICATIONS_ERROR';

export const ADD_MEDICATION_REQUEST = 'ADD_MEDICATION_REQUEST';
export const ADD_MEDICATION_SUCCESS = 'ADD_MEDICATION_SUCCESS';
export const ADD_MEDICATION_ERROR = 'ADD_MEDICATION_ERROR';

export const DELETE_MEDICATION_REQUEST = 'DELETE_MEDICATION_REQUEST';
export const DELETE_MEDICATION_SUCCESS = 'DELETE_MEDICATION_SUCCESS';
export const DELETE_MEDICATION_ERROR = 'DELETE_MEDICATION_ERROR';

export const EDIT_MEDICATION_REQUEST = 'EDIT_MEDICATION_REQUEST';
export const EDIT_MEDICATION_SUCCESS = 'EDIT_MEDICATION_SUCCESS';
export const EDIT_MEDICATION_ERROR = 'EDIT_MEDICATION_ERROR';

export const GET_PATIENT_MEDICATIONS_REQUEST = 'GET_PATIENT_MEDICATIONS_REQUEST';
export const GET_PATIENT_MEDICATIONS_SUCCESS = 'GET_PATIENT_MEDICATIONS_SUCCESS';
export const GET_PATIENT_MEDICATIONS_ERROR = 'GET_PATIENT_MEDICATIONS_ERROR';

export const GET_PATIENT_SCHEDULES_REQUEST = 'GET_PATIENT_SCHEDULES_REQUEST';
export const GET_PATIENT_SCHEDULES_SUCCESS = 'GET_PATIENT_SCHEDULES_SUCCESS';
export const GET_PATIENT_SCHEDULES_ERROR = 'GET_PATIENT_SCHEDULES_ERROR';

export const MODIFY_CLICKING_DATA = 'MODIFY_CLICKING_DATA';
export const MODIFY_CLICKING_DATA_REQUEST = 'MODIFY_CLICKING_DATA_REQUEST';
export const MODIFY_CLICKING_DATA_SUCCESS = 'MODIFY_CLICKING_DATA_SUCCESS';
export const MODIFY_CLICKING_DATA_ERROR = 'MODIFY_CLICKING_DATA_ERROR';

export const GET_ALARMS = 'GET_ALARMS';
export const GET_ALARMS_REQUEST = 'GET_ALARMS_REQUEST';
export const GET_ALARMS_SUCCESS = 'GET_ALARMS_SUCCESS';
export const GET_ALARMS_ERROR = 'GET_ALARMS_ERROR';

export const RESOLVE_ALARMS = 'RESOLVE_ALARMS';
export const RESOLVE_ALARMS_REQUEST = 'RESOLVE_ALARMS_REQUEST';
export const RESOLVE_ALARMS_SUCCESS = 'RESOLVE_ALARMS_SUCCESS';
export const RESOLVE_ALARMS_ERROR = 'RESOLVE_ALARMS_ERROR';

export const GET_ALL_EXERCISES = 'GET_ALL_EXERCISES';
export const GET_ALL_EXERCISES_SUCCESS = 'GET_ALL_EXERCISES_SUCCESS';

export const CHANGE_EXERCISES_ACTIVE_STATUS = 'CHANGE_EXERCISES_ACTIVE_STATUS';
export const CHANGE_EXERCISES_ACTIVE_STATUS_SUCCESS = 'CHANGE_EXERCISES_ACTIVE_STATUS_SUCCESS';
export const CHANGE_EXERCISES_ACTIVE_STATUS_ERROR = 'CHANGE_EXERCISES_ACTIVE_STATUS_ERROR';

export const GET_PATIENT_EXERCISES = 'GET_PATIENT_EXERCISES';
export const GET_PATIENT_EXERCISES_SUCCESS = 'GET_PATIENT_EXERCISES_SUCCESS';
export const GET_PATIENT_EXERCISES_ERROR = 'GET_PATIENT_EXERCISES_ERROR';

export const ASSIGN_EXERCISES = 'ASSIGN_EXERCISES';
export const ASSIGN_EXERCISES_SUCCESS = 'ASSIGN_EXERCISES_SUCCESS';
export const ASSIGN_EXERCISES_ERROR = 'ASSIGN_EXERCISES_ERROR';
export const ASSIGN_EXERCISES_HIDE_SUCCESS_MODAL = 'ASSIGN_EXERCISES_HIDE_SUCCESS_MODAL';
export const SET_EXERCISE_DURATION = 'SET_EXERCISE_DURATION';

export const SET_CURRENT_PATIENT = 'SET_CURRENT_PATIENT';

export const GET_EXERCISE_PERFORMANCE_DATA = 'GET_EXERCISE_PERFORMANCE_DATA';
export const GET_EXERCISE_PERFORMANCE_DATA_SUCCESS = 'GET_EXERCISE_PERFORMANCE_DATA_SUCCESS';
export const GET_EXERCISE_PERFORMANCE_DATA_ERROR = 'GET_EXERCISE_PERFORMANCE_DATA_ERROR';
export const SET_TABLE_STATE = 'SET_TABLE_STATE';
export const GET_TOTAL_PATIENTS_SUCCESS = 'GET_TOTAL_PATIENTS_SUCCESS';
